<template>
  <div>
    <transition name="fade" appear>
      <main class="login">
        <section class="login__wrapper" v-if="tokenChecked">
          <div class="login__left">
            <img class="login__image" alt="login image" :src="imageSrc" />
          </div>
          <div class="login__right">
            <nav>
              <a href="/">
                <img class="login__logo" src="@/assets/images/brand/logo_full.svg" alt="Early Stage Online" />
              </a>
            </nav>
            <section class="login__form-wrapper">
              <div class="login__form" v-if="!invalidToken">
                <div class="login__form-heading">
                  <h1 class="text-heading-m text-color-grey-900">Ustaw nowe hasło</h1>
                  <p class="text-body-large text-color-grey-700">
                    Za pomocą nowego hasła będziesz logować się także do Early Stage MUSIC
                  </p>
                </div>
                <form @submit.prevent="submit" class="w-full">
                  <div class="w-full login__form-content">
                    <PasswordInput class="w-full" type="password" name="password" passwordEye v-model="password"
                      autocomplete="new-password" :applyErrorStyle="isError" :noMargin="true">
                      Nowe hasło
                    </PasswordInput>
                    <PasswordInput class="w-full" type="password" name="password" passwordEye v-model="passwordConfirm"
                      autocomplete="new-password" :applyErrorStyle="isError" :noMargin="true">
                      Powtórz hasło
                    </PasswordInput>
                    <div v-if="isError" class="login__form-error">
                      <span class="error-wrapper text-color-error-700">
                        <img class="information-icon" src="@/assets/images/icons/i_error.svg" alt="error" />
                        {{ errorText }}
                      </span>
                    </div>
                    <div class="login__validation">
                      <p class="text-body-small-long">Twoje hasło musi zawierać:</p>
                      <div class="login__validation-wrapper">
                        <div class="login__validation-item">
                          <img :src="passwordValidation.minLength
                            ? require('@/assets/images/login/login-password-check.svg')
                            : require('@/assets/images/login/login-password-mark.svg')
                            " alt="check" />
                          <span class="text-body-small-long">minimum 10 znaków</span>
                        </div>
                        <div class="login__validation-item">
                          <img :src="passwordValidation.specialChar
                            ? require('@/assets/images/login/login-password-check.svg')
                            : require('@/assets/images/login/login-password-mark.svg')
                            " alt="check" />
                          <span class="text-body-small-long">co najmniej 1 znak specjalny</span>
                        </div>
                        <div class="login__validation-item">
                          <img :src="passwordValidation.upperLowerCase
                            ? require('@/assets/images/login/login-password-check.svg')
                            : require('@/assets/images/login/login-password-mark.svg')
                            " alt="check" />
                          <span class="text-body-small-long">co najmniej 1 małą i dużą literę</span>
                        </div>
                        <div class="login__validation-item">
                          <img :src="passwordValidation.digit
                            ? require('@/assets/images/login/login-password-check.svg')
                            : require('@/assets/images/login/login-password-mark.svg')
                            " alt="check" />
                          <span class="text-body-small-long">co najmniej 1 cyfrę</span>
                        </div>
                      </div>
                    </div>
                    <button type="submit" class="esc-button" :disabled="!Object.values(passwordValidation).every(Boolean) || !passwordConfirm || isDisable
                      ">
                      Zmień hasło
                    </button>
                  </div>
                </form>
              </div>
              <div v-else class="login__form">
                <div class="login__form-heading">
                  <h1 class="text-heading-m text-color-grey-900">Link do zmiany hasła wygasł</h1>
                  <p class="text-body-large text-color-grey-500">
                    Wygląda na to, że ten link nie jest już aktywny.
                  </p>
                  <p class="login__form-heading-additional text-body-large text-color-grey-500">
                    Kliknij w poniższy przycisk, aby otrzymać nową wiadomość z linkiem do zresetowania hasła.
                  </p>
                  <router-link :to="{ path: '/zapomnialem-hasla' }" class="login__form-heading-additional esc-button">
                    Przejdź do odzyskiwania hasła
                  </router-link>
                </div>
              </div>
            </section>
            <footer class="login__footer">
              <a class="esc-link-tonal" :href="REGULATIONS_PATH" target="_blank">Regulamin</a>
              <a class="esc-link-tonal" href="/Polityka_Prywatności_ES_Online.pdf" target="_blank">Polityka
                prywatności</a>
            </footer>
          </div>
        </section>
      </main>
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PasswordInput from '@/components/Form/BasePasswordInput.vue';

export default {
  name: 'ResetPasswordNew',
  components: {
    PasswordInput,
  },

  data() {
    return {
      password: null,
      passwordConfirm: null,
      isError: false,
      errorText: '',
      isOnline: navigator.onLine,
      isDisable: false,
      invalidToken: false,
      tokenChecked: false,
    };
  },

  computed: {
    ...mapState('layout', ['isLoading']),
    passwordValidation() {
      const password = this.password || '';
      const rules = {
        minLength: password.length >= 10,
        specialChar: /\W+/g.test(password),
        upperLowerCase: /[a-z]/.test(password) && /[A-Z]/.test(password),
        digit: /[0-9]+/g.test(password),
      };
      return rules;
    },
    imageSrc() {
      return this.invalidToken
        ? require('@/assets/images/login/webinar-pana.svg')
        : require('@/assets/images/login/new-password.svg');
    },
  },

  methods: {
    ...mapActions('auth', ['checkToken', 'resetPassword']),

    async submit() {
      this.isDisable = true;


      if (!this.invalidToken) {
        this.$store.commit('layout/startLoading');
        try {
          this.$store.commit('layout/startLoading');
          await this.resetPassword({
            token: this.$route.params.token,
            password: this.password,
            passwordConfirmation: this.passwordConfirm,
          });
          this.routerPush({ name: 'Auth.Login' });
          this.isDisable = false;
        } catch (e) {
          this.isError = true;
          this.errorText = e.response.data.errors.fields.passwordConfirmation || e.response.data.errors.fields.token;
        } finally {
          this.isDisable = false;
          this.$store.commit('layout/finishLoading');
        }
      }
    },
  },
  async created() {
    this.$store.commit('layout/startLoading');
    try {
      const response = await this.checkToken({ token: this.$route.params.token });
      const { correct } = response;
      if (!correct) {
        this.invalidToken = true;
      }
    } catch (e) {
      this.invalidToken = true;
    } finally {
      this.$store.commit('layout/finishLoading');
      this.tokenChecked = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.login {
  padding: 24px;
  padding-top: 40px;
  min-height: 100dvh;
  display: flex;

  @media screen and (min-width: 768px) {
    padding: 40px;
  }

  @media screen and (min-width: 1024px) {
    padding: 24px;
  }

  &__wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 768px) {}

    @media screen and (min-width: 1024px) {
      display: grid;
      align-items: center;
      grid-template-columns: 1fr 1fr;
      gap: 40px;
    }
  }

  &__left {
    border-radius: 24px;
    background: #e8f4ff;
    display: none;
    padding: 24px;
    justify-content: center;
    align-items: center;
    height: 100%;

    @media screen and (min-width: 768px) {}

    @media screen and (min-width: 1024px) {
      display: flex;
    }
  }

  &__right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 24px;
    height: 100%;
    width: 100%;
  }

  &__image {
    max-width: 610px;
    max-height: 610px;
    width: 100%;
    height: 100%;
  }

  &__form-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0 0;
    align-self: stretch;

    @media screen and (min-width: 768px) {
      min-height: 480px;
    }
  }

  &__form {
    display: flex;
    width: 100%;
    max-width: 480px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 24px;

    &-content {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    &-heading {
      display: flex;
      gap: 8px;
      flex-direction: column;
    }

    &-heading-additional {
      margin-top: 16px;
    }

    &-error {
      display: flex;
      align-items: center;
      margin-top: -16px;
    }
  }

  &__validation {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    align-self: stretch;

    &-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      align-self: stretch;
    }

    &-item {
      display: flex;
      align-items: center;
      gap: 8px;
      align-self: stretch;
    }
  }

  &__logo {
    width: 140px;
    height: 38px;
  }

  &__footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 24px;

    @media screen and (min-width: 768px) {}

    @media screen and (min-width: 1024px) {
      display: flex;
    }
  }
}
</style>
